import { ModelError } from './ModelError';

export const UNAUTHORIZED_ERROR_NAME = 'UNAUTHORIZED_ERROR';

export class UnauthorizedError extends ModelError {
  public readonly name: string = UNAUTHORIZED_ERROR_NAME;
}
